<template>
    <NuxtLayout name="main" :top="0">
        <ModuleDetail mode="Model" v-bind="options" :data="data">
            <ModuleComponent1 :origin="data" ref="module1" @move3="methods.move(module3)" />
            <ModuleComponent2 ref="module2" />
            <ModuleComponent3 ref="module3" />
        </ModuleDetail>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 公共组件
import ModuleDetail from "../components/container/index.vue";
//* 内部组件
import ModuleComponent1 from "./components/module1/index.vue";
import ModuleComponent2 from "./components/module2/index.vue";
import ModuleComponent3 from "./components/module3/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
import { mask } from "./src/mask";
//* 插件
const route = useRoute();

//* 组合函数
const { nodes, methods, computeds } = useComposable();
const { module1, module2, module3 } = nodes;
const { options } = computeds;

if (mask.includes(route.params.id as string)) {
    useHead({
        meta: [
            {
                name: "robots",
                content: "noindex, follow",
            },
        ],
    });
}

//* 初始化页面数据
const data = await api.server("ModelDetails", "/api/model", {
    data: { id: route.params.id },
    method: "POST",
});

onMounted(async () => {
    //* 请求列表
    const requests: Promise<any>[] = [];

    //* 请求注册
    requests.push(methods.register("/api/model/characteristic", module2.value));

    //* 批量请求
    try {
        Promise.all(requests).then(() => {
            nextTick(() => {
                if (route.query.module) {
                    const module = route.query.module as "module1" | "module2" | "module3";
                    setTimeout(() => methods.move(nodes[module].value), 1000);
                }
            });
        });
    } catch {}
});
</script>
